import {ReadAbstract, template as tpl} from "./ReadAbstract";
import {IExportFlow, ITableColumn} from "../../../../index";
import Transform from "../Transform";
import {global} from "../../../../appContext";
import {nsFa} from "../../../fa/fn";
import {nsDynamicVariable} from "../../../dynamic-variable/nsDynamicVariable";
import {isSupported} from "../../../../util/misc";
import {TEXT_WRAPPER_START} from "../../../../constants";
import {getHash} from "../../../../constants/RouteDefinitions";
import i = nsFa.i;

export let template = tpl;

export class viewModel extends ReadAbstract {
    protected readonly TableColumns: ITableColumn<IExportFlow>[] = [
        {key: "id", sort: true},
        {key: "expression", label: "source", sort: true},
        {key: "targetattribute", label: "target", sort: true},
        {key: "nullable", label: "empty target", sort: true, yesno: true, getContent: o => isSupported(o.nullable)},
        {key: "sourceattribute", label: "remote key", sort: true},
        {key: "$ruleset", label: "ruleset", sort: true},
        {key: "func", label: "", sort: false, binding: true}
    ];

    protected override getCellContent(key: string, val: any, item: any): string | number | any[] | null {
        if (key == "expression" && val.indexOf("[TRANSFORM;") == 0 && nsDynamicVariable.validateExpression(val)) {
            return new Transform(val).getOutput();
        }

        switch (key) {
            case "sourceattribute": {
                if (item.targetattributetype != 'Reference') {
                    return null
                }
                return item.sourceattribute?.startsWith(TEXT_WRAPPER_START)
                    ? item.sourceattribute
                    : item.objecttype?.name + "." + item.sourceattribute
                    ;
            }
            case "$ruleset":
                return item.ruleset
                    ? `<a href="${getHash('rulesetdetails', {id: item.ruleset.id})}" title="${item.ruleset.name} [Regelsett]">${item.ruleset.name}</a>`
                    : null
                    ;
            case "func":
                return global.permissionValidator.isMinCompanyAdmin() && this.exportTemplate?.active
                    ? `<a class="btn btn-default btn-func" data-bind="attr: {href: '${getHash('exportflows', {id: global.getRouteId()})}/' + $parent.id}, tt: 'export attribute'">${i('fa-play')}</a>`
                    : null
                    ;
        }

        return this.getCellText(key, val, item);
    }

    protected override getCellText(key: string, val: any, item: any): string | number | any[] | null {
        switch (key) {
            case "$fn":
                return "Eksporter mapping";
        }

        return super.getCellText(key, val, item);
    }

}
